import { useMutation, useQuery } from 'react-query';
import { useSearchParams, useParams } from 'react-router-dom';
import React, { useEffect } from 'react';
import useDateRangePicker from '../../../../../components/organisms/forms/date-range-picker/reusable-func';
import api from '../../../../../components/api';

interface Inventory {
  apCode: string
  extension: boolean
  id: number
  isDrink: boolean
  maxCount: number
  price: number
  productId: number
  productImage: string
  productName: string
  productUpc: string
  quantity: number
  rowNumber: number
  slots: number
  sprialCount: number
  vmId: number
}

function useScheduledRestocking() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const getDateFormat = (date: string) => {
    const [year, month, day] = date.split('-');
    return `${month}/${day}/${year}`;
  };

  const schDate = new Date(searchParams.get('scheduleDate')!);
  const schDateStr = getDateFormat(searchParams.get('scheduleDate')!);
  const scheduleId = searchParams.get('scheduleId');
  console.log(schDateStr, schDate);

  const vmType = searchParams.get('type');
  console.log(vmType);

  const { handleChangeStartDate, handleChangeEndDate, selectedDate } = useDateRangePicker();
  console.log(selectedDate);

  const { data, isLoading, refetch } = useQuery(
    ['getInventoryByVmId', 'vendingMachines', id],
    () => {
      const vmId = id!;
      console.log('getting coffee orders...');
      if ((vmType === '4') || (vmType === '5')) return api.vendingMachine.getCoffeeOrder(id!, schDateStr!);
      return api.vendingMachine.getVMSales({ ...selectedDate, vmId });
    },
  );

  useEffect(() => {
    refetch();
  }, [selectedDate]);

  const [searchValue, setSearchValue] = React.useState<string>('');
  const handleSearchChange = (text:string) => {
    setSearchValue(text);
  };

  const [resultData, setResultData] = React.useState<Inventory[]>([]);
  useEffect(() => {
    if (data?.data?.data) {
      const fetchData: Inventory[] = data.data.data;
      const filteredData = fetchData.filter((x) => x.productName.toLowerCase().includes(searchValue.toLowerCase()));
      setResultData(filteredData);
    }
  }, [data, searchValue]);

  const onIncreaseCount = (inventory: Inventory, index: number) => {
    console.log(inventory.maxCount);
    const maxVal = (inventory.maxCount !== null) ? inventory.maxCount : 1000;
    if (inventory.quantity < maxVal) {
      resultData[index].quantity += 1;
      setResultData([...resultData]);
    }
  };

  const onDecreaseCount = (inventory: Inventory, index: number) => {
    if (inventory.quantity > 0) {
      resultData[index].quantity -= 1;
      setResultData([...resultData]);
    }
  };

  const { isLoading: loadingCoffeeSales, mutate: coffeeOrder } = useMutation(api.schedules.updateCoffeeOrder, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      console.log(res);
      alert('success');
    },
    onError: (err) => {
      console.log('err', err);
      alert('error');
    },
  });

  const handleCoffeeSalesUpdate = () => {
    console.log(resultData);
    const items = resultData.map((item) => ({
      vmInvId: item.id,
      price: item.price,
      quantity: item.quantity,
      productId: item.productId,
    }));

    coffeeOrder({
      vmId: Number(id),
      dropDate: schDateStr,
      routeScheduleId: Number(scheduleId),
      salesItems: items,
    });
    console.log(items);
  };

  return {
    resultData,
    isLoading,
    onDecreaseCount,
    onIncreaseCount,
    searchValue,
    handleSearchChange,
    selectedDate,
    handleChangeEndDate,
    handleChangeStartDate,
    vmType,
    schDateStr,
    handleCoffeeSalesUpdate,
  };
}

export default useScheduledRestocking;
